import NextGenSim from "@/assets/carousel/Logitech-G_home.webp";

export const logitechCarousel = [
  {
    coverURL: NextGenSim,
    logoURL:
      "https://resource.logitechg.com/w_184,c_limit,q_auto,f_auto,dpr_1.0/d_transparent.gif/content/dam/gaming/en/products/g923-and-trueforce/g923-trueforce-logo.png?v=1%201x,%20https://resource.logitechg.com/w_184,c_limit,q_auto,f_auto,dpr_2.0/d_transparent.gif/content/dam/gaming/en/products/g923-and-trueforce/g923-trueforce-logo.png?v=1%202x",
    alt: "Logitech G",
    heading: "NEXT-GEN SIMULATION",
    desc: "Our latest innovation in force feedback technology connects directly to in-game simulation engines and physics to produce higher fidelity, real-time responses. The feedback frequency range is also increased for dramatically improved detail and realism compared to previous generations.",
    links: [
      {
        text: "More on TRUEFORCE technology",
        url: "https://www.logitechg.com/en-eu/innovation/trueforce.html",
      },
    ],
    theme: "logitech",
  },
];
